var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamelevel1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 101,
    viewBox: "0 0 139 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1916 97.0091C62.0569 107.055 80.5403 91.4945 101.353 84.6617C101.368 84.6565 101.388 84.6519 101.419 84.6421C102.125 84.4046 102.836 84.1874 103.546 83.9755C104.899 83.5757 106.262 83.2198 107.644 82.9143C131.213 77.6758 125.042 62.8994 133.272 55.0401C138.604 49.9547 139.073 44.9492 137.67 40.9846C137.661 40.9597 137.656 40.9355 137.651 40.9191C137.646 40.9028 137.636 40.8799 137.631 40.8596C136.882 38.8761 135.715 37.0766 134.21 35.5826C131.969 33.3359 129.821 29.7174 126.4 25.6297H126.395C120.401 18.4613 110.493 9.85619 89.3083 4.71197C56.3396 -3.29125 39.3126 13.6573 26.3058 26.7301C23.6156 29.4308 21.1027 31.9686 18.6513 34.0818C16.8102 35.7379 14.7803 37.1712 12.6035 38.3519C12.5933 38.3578 12.5835 38.3644 12.5741 38.3716C9.48445 40.0625 6.88025 42.5178 5.01052 45.5027C4.48395 46.2953 4.00107 47.116 3.56402 47.9613C-4.0833 62.6723 -1.09673 87.7523 29.1916 97.0091Z",
    fill: "url(#paint0_linear_2_11321)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1915 97.0091C65.3202 108.052 84.0705 88.1521 107.644 82.9143C131.218 77.6765 125.042 62.8994 133.272 55.0401C141.502 47.1808 138.139 39.5184 134.21 35.5839C131.969 33.3372 129.821 29.7187 126.4 25.631H126.395C131.396 32.1819 134.582 36.1485 134.769 43.6283C134.955 51.1081 132.147 51.1095 126.163 64.3943C121.994 73.6406 113.975 77.7714 100.159 83.0091C94.1306 85.2944 87.7074 88.7755 78.8307 91.3342C37.2981 103.307 1.93819 80.1096 1.93819 62.7122C1.93819 45.8573 11.9479 38.7974 12.5727 38.3748C-3.49586 46.6718 -9.94332 85.0464 29.1915 97.0091Z",
    fill: "url(#paint1_linear_2_11321)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.459 28.6321C131.874 42.6288 109.253 75.5654 68.7713 79.307C28.29 83.0486 7.83613 72.0732 13.5737 51.6186C19.3114 31.164 45.5003 24.6786 52.986 21.4362C60.4717 18.1939 48.5568 19.4376 46.4378 16.6963C44.3187 13.9551 64.9159 1.71442 90.0096 7.98786C115.103 14.2613 118.469 26.2377 118.655 27.1732C118.842 28.1088 119.811 26.4136 121.459 28.6321Z",
    fill: "url(#paint2_linear_2_11321)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.091 28.19C121.091 28.19 128.069 39.7699 111.481 57.1071C94.8929 74.4442 53.1103 83.7997 29.2884 74.8171C5.46652 65.8345 17.5365 43.1261 17.5365 43.1261C17.5365 43.1261 7.5267 55.111 14.4786 67.0848C21.4304 79.0585 49.5559 86.6038 88.3414 77.8731C127.127 69.1423 127.957 32.2004 121.091 28.19Z",
    fill: "url(#paint3_linear_2_11321)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.296 75.4324C108.296 75.4324 90.3282 87.1615 63.6774 89.7444C37.0266 92.3273 37.7698 84.0381 27.4768 82.0735C17.1837 80.1088 14.1003 74.5904 14.1003 74.5904C14.1003 74.5904 15.223 77.6149 25.9799 80.0316C36.7368 82.4484 37.5709 86.43 48.6163 88.2475C59.6617 90.0649 89.3082 85.1608 108.296 75.4324Z",
    fill: "url(#paint4_linear_2_11321)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.1414 84.506C83.6965 83.2897 54.5112 80.6879 43.1923 81.3761C31.8734 82.0644 46.4667 93.7666 80.1414 84.506Z",
    fill: "#FFDD81"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.4913 86.7859C83.7893 86.5635 68.3226 95.9524 48.6027 94.2985C28.8829 92.6446 25.4187 84.0381 25.4187 84.0381C25.4187 84.0381 30.6571 87.4055 48.6171 89.8379C66.5771 92.2703 80.4913 86.7859 80.4913 86.7859Z",
    fill: "#FFDD81"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5704 87.0668C90.5704 87.0668 74.2571 97.1727 47.1523 95.2637C20.0475 93.3546 10.4839 84.8771 10.4839 84.8771C10.4839 84.8771 26.0742 99.7537 48.0257 99.5037C69.9771 99.2538 90.5704 87.0668 90.5704 87.0668Z",
    fill: "url(#paint5_linear_2_11321)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6138 84.0381C77.9578 87.6371 69.6533 89.6512 61.1992 89.9595C47.4956 90.352 40.8395 88.8944 37.3387 86.5575C35.0136 84.9755 32.7927 83.2456 30.6897 81.3786C30.6897 81.3786 35.1012 83.62 42.5378 87.0809C49.9745 90.5418 71.3973 87.5938 85.6138 84.0381Z",
    fill: "url(#paint6_linear_2_11321)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.022 78.8001C14.1012 77.8645 8.19998 58.3272 15.1767 45.7797C21.6844 34.0768 24.2051 32.2789 24.2051 32.2789C24.2051 32.2789 7.84407 37.5867 3.22062 53.5127C-1.83202 70.9113 12.022 78.8001 12.022 78.8001Z",
    fill: "#FFDD81"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0658 64.7388C107.629 56.0375 71.8383 33.2394 35.7849 42.7219C-0.268524 52.2043 23.431 71.8476 50.9598 74.1865C78.4886 76.5254 88.815 68.1061 94.0658 64.7388Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.527 15.3785C114.649 23.8181 56.8918 19.4563 54.0118 13.4453C51.1319 7.43418 84.3957 0.857176 103.527 15.3785Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9367 21.9319C88.0764 24.9924 80.5782 27.3392 74.4664 25.631C68.3545 23.9228 77.9724 20.6614 80.9367 21.9319Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.546 83.9753C104.899 83.5755 106.262 83.2196 107.644 82.9141C131.213 77.6757 125.042 62.8992 133.272 55.0399C138.604 49.9546 139.073 44.949 137.67 40.9844C137.848 41.6314 138.475 44.756 135.207 49.1158C131.529 54.0226 130.093 56.1606 128.409 60.841C126.726 65.5214 124.227 75.0594 115.938 78.9887C111.913 80.901 107.774 82.5662 103.546 83.9753Z",
    fill: "url(#paint7_linear_2_11321)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.683 35.9585C134.345 38.9752 136.921 45.2192 128.503 56.9116C120.084 68.604 115.968 69.1654 115.313 68.9783C114.659 68.7912 120.8 57.5855 123.202 47.0523C125.603 36.5192 129.942 33.9854 131.683 35.9585Z",
    fill: "#FFDD81"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.253 38.8997C39.3537 39.2183 38.2271 40.2612 37.3151 39.6998C36.4031 39.1385 37.4565 37.5651 37.9072 37.7371C38.2031 37.8202 38.4771 37.9675 38.7097 38.1684C38.9423 38.3693 39.1278 38.619 39.253 38.8997Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.9334 74.0899C59.8188 75.3944 45.5939 51.3612 33.6515 48.6167C21.7092 45.8722 16.9738 54.126 19.6509 61.2872C22.3281 68.4485 37.8726 72.4988 49.9334 74.0899Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.362 7.45833C111.259 6.16491 104.54 0.478968 101.351 0.0399782C98.1622 -0.399012 98.2263 2.84403 98.7876 7.02196C99.349 11.1999 109.715 8.39388 110.362 7.45833Z",
    fill: "#9ADD00"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.955 70.069C122.484 67.452 113.071 54.9922 107.613 54.9228C102.156 54.8535 91.5713 75.0483 91.3757 77.1111C91.1801 79.1739 107.838 80.4889 118.955 70.069Z",
    fill: "url(#paint8_linear_2_11321)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.481 57.1068C114.664 59.1958 114.939 66.7018 108.297 70.8175C101.656 74.9333 92.7338 73.7576 92.6762 73.8787C92.6187 73.9997 103.868 55.1382 106.468 55.1676C109.069 55.1971 111.481 57.1068 111.481 57.1068Z",
    fill: "#D96840"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.597 69.1593C120.229 67.9764 118.275 62.6209 113.971 65.1462C113.244 65.5734 111.82 69.3751 106.573 71.7493C101.327 74.1236 94.2889 78.3852 94.0776 78.3519C93.8663 78.3185 94.8287 81.0813 107.083 78.5377C119.338 75.994 119.597 69.1593 119.597 69.1593Z",
    fill: "#DB83A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.981 68.8219C112.313 66.0414 112.819 62.7108 108.952 61.526C105.086 60.3411 100.251 68.3542 100.659 70.5059C101.066 72.6577 108.362 70.7552 109.981 68.8219Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.053 57.2232C107.658 57.5981 103.873 63.9264 101.754 65.4233C99.6347 66.9202 103.932 55.2899 107.053 57.2232Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3738 63.6493C92.5056 59.6153 82.2145 55.5427 67.1861 60.1577C52.1578 64.7726 59.3583 71.839 65.8607 72.7543C72.3631 73.6695 90.009 68.5103 91.3738 63.6493Z",
    fill: "url(#paint9_linear_2_11321)"
  }), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.9368 64.5559C92.1798 61.9625 87.0637 58.2831 73.1574 60.2785C59.251 62.274 58.358 68.1293 59.0299 69.0034C59.7018 69.8774 59.1306 74.2477 72.473 72.6265C85.8154 71.0053 90.9368 64.5559 90.9368 64.5559Z",
    fill: "#86A500"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.296 51.472C110.288 50.348 106.094 44.297 94.9819 45.686C83.8698 47.0749 98.6004 56.9459 108.296 51.472Z",
    fill: "url(#paint10_linear_2_11321)"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.904 51.6834C109.075 50.6752 105.654 46.723 98.3884 46.5045C91.1231 46.286 90.9772 48.2487 91.1139 48.5542C91.2507 48.8597 92.9321 51.8908 98.6298 52.827C104.327 53.7632 107.904 51.6834 107.904 51.6834Z",
    fill: "#639100"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1105 41.8824C96.0575 43.6043 90.1818 45.6115 85.5047 43.8713C80.8276 42.131 90.8675 39.0136 94.1105 41.8824Z",
    fill: "url(#paint11_linear_2_11321)"
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.9821 43.4059C94.9523 42.35 88.094 40.0504 84.374 43.1259C84.374 43.1259 85.0224 44.3153 88.5448 44.5096C92.0671 44.7039 93.9821 43.4059 93.9821 43.4059Z",
    fill: "#639100"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.4615 60.1538C97.0002 60.2101 92.0503 50.4261 82.2617 48.4928C72.473 46.5596 65.5493 55.951 64.4888 57.5212C63.4283 59.0914 79.8678 56.1395 91.4615 60.1538Z",
    fill: "#9ADD00"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.951 71.0485C106.234 71.2952 104.531 71.6281 102.848 72.0462C100.696 72.6265 99.9783 73.6334 99.9783 73.6334C99.9783 73.6334 103.231 74.1247 107.951 71.0485Z",
    fill: "#B2562B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.226 74.5905C113.817 73.4214 108.379 71.9245 103.965 73.4214C99.5517 74.9183 97.9612 77.8179 97.9148 78.0985C97.8683 78.3792 104.556 78.145 112.226 74.5905Z",
    fill: "#9ADD00"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.772 65.9179C112.772 65.9179 109.959 69.931 107.387 70.421C102.114 71.4272 101.516 72.0127 99.481 72.8573C97.4463 73.702 93.939 73.946 93.939 73.946C93.939 73.946 96.2445 73.963 99.9795 73.6333C100.959 72.8369 102.117 72.2921 103.355 72.0461C105.444 71.6202 107.951 71.176 107.951 71.176C110.066 69.9678 111.752 68.1297 112.772 65.9179Z",
    fill: "#EA8E40"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07753 66.7332C8.75596 65.7106 8.05201 63.428 6.24568 63.2095C4.43934 62.991 3.5823 64.2072 3.24537 65.7976C2.90844 67.388 6.91823 68.4793 8.07753 66.7332Z",
    fill: "#D36F3B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.62733 62.3356C11.5593 62.5496 11.0195 59.4119 8.77683 58.3775C6.53412 57.3432 4.02514 61.7167 9.62733 62.3356Z",
    fill: "#D36F3B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8014 80.9207C18.8926 79.9394 16.661 78.8161 15.8387 79.7981C15.0163 80.7801 16.7101 81.9021 17.8014 80.9207Z",
    fill: "#D36F3B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7003 60.5684C11.0137 61.6806 9.67317 62.3211 7.67777 61.5262C5.68236 60.7314 6.47071 59.1821 6.47071 59.1821C6.16917 59.6576 5.96873 60.1901 5.8819 60.7464C5.83545 61.466 7.34542 62.8471 9.99833 62.8046C12.6512 62.7621 10.7003 60.5684 10.7003 60.5684Z",
    fill: "#DB83A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19859 64.9577C8.19859 64.9577 8.92217 66.2891 6.47469 66.7097C4.02721 67.1304 3.42531 65.1239 3.42531 65.1239C3.19525 65.5219 3.08485 65.9778 3.10736 66.4369C3.18521 67.0911 4.65069 68.2923 7.5195 67.731C10.3883 67.1697 8.19859 64.9577 8.19859 64.9577Z",
    fill: "#DB83A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8812 79.8741C18.4628 80.438 17.0477 80.9372 16.2993 80.8554C15.5508 80.7737 15.6202 80.2745 15.6202 80.2745C15.6202 80.2745 15.2675 81.21 16.8593 81.3618C18.451 81.5136 18.7474 80.1776 17.8812 79.8741Z",
    fill: "#DB83A9"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77785 63.4591C6.68723 63.7862 6.24759 65.0738 5.21652 65.4041C4.91213 65.4909 4.58854 65.4828 4.28885 65.381C3.98916 65.2792 3.72761 65.0885 3.53906 64.8343C3.53906 64.8343 4.12722 62.8638 5.77785 63.4591Z",
    fill: "#E7792C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32936 58.6417C9.16809 59.0604 8.28356 59.9672 7.41343 59.8579C7.3076 59.8607 7.20257 59.8387 7.1068 59.7936C7.01102 59.7485 6.92716 59.6815 6.86195 59.5981C6.79674 59.5147 6.752 59.4172 6.73131 59.3133C6.71063 59.2095 6.71458 59.1023 6.74285 59.0002C6.74285 59.0002 7.58223 58.2675 8.32936 58.6417Z",
    fill: "#E7792C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9621 80.2583C17.1727 79.9109 16.8175 79.5354 16.3458 79.5059C15.8741 79.4765 15.7406 80.2694 15.7982 80.3878C15.8558 80.5062 16.6565 80.7607 16.9621 80.2583Z",
    fill: "#E7792C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.1925 66.4405C57.2837 65.4592 55.0521 64.3359 54.2298 65.3179C53.4074 66.2999 55.1012 67.4225 56.1925 66.4405Z",
    fill: "#D36F3B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2696 65.397C56.8512 65.961 55.4361 66.4602 54.6883 66.3784C53.9405 66.2966 54.0086 65.7974 54.0086 65.7974C54.0086 65.7974 53.6559 66.733 55.2477 66.8847C56.8394 67.0365 57.1352 65.698 56.2696 65.397Z",
    fill: "#DB83A9"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3529 65.7788C55.5636 65.4314 55.2084 65.0552 54.7367 65.0265C54.265 64.9977 54.1315 65.79 54.1891 65.9084C54.2466 66.0268 55.0474 66.2813 55.3529 65.7788Z",
    fill: "#E7792C"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4154 81.3072C91.9797 79.8993 88.7798 78.2906 87.5983 79.6985C86.4168 81.1064 88.8512 82.7151 90.4154 81.3072Z",
    fill: "#D36F3B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.5259 79.8085C91.3594 80.6171 89.332 81.3322 88.259 81.2151C87.1861 81.098 87.2849 80.3822 87.2849 80.3822C87.2849 80.3822 86.7798 81.7228 89.0611 81.9406C91.3424 82.1585 91.7709 80.2435 90.5259 79.8085Z",
    fill: "#DB83A9"
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.2121 80.3589C89.5144 79.861 89.0054 79.322 88.3289 79.2808C87.6524 79.2395 87.4614 80.3746 87.5438 80.5447C87.6263 80.7148 88.7745 81.0792 89.2121 80.3589Z",
    fill: "#E7792C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.986 69.9296C52.0161 67.7326 48.6919 66.0761 46.3164 68.9757C43.9409 71.8752 51.9415 73.1196 51.986 69.9296Z",
    fill: "#D36F3B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.7529 68.922C51.8108 69.2112 51.8071 69.5094 51.7421 69.7971C51.677 70.0848 51.5521 70.3555 51.3755 70.5917C51.1988 70.8279 50.9744 71.0243 50.7168 71.168C50.4593 71.3117 50.1743 71.3995 49.8805 71.4257C47.5737 71.8621 45.7589 70.5366 46.1514 69.2014C45.7686 69.548 45.4986 70.0015 45.3761 70.5033C45.2047 71.2982 47.0595 72.7322 50.4739 72.483C53.8884 72.2337 52.2816 69.6345 51.7529 68.922Z",
    fill: "#DB83A9"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5657 68.6743C48.3567 68.6743 48.2566 69.8827 47.0044 69.7734C45.7522 69.6642 46.9809 68.6743 47.5657 68.6743Z",
    fill: "#E7792C"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2627 40.4561C19.8524 37.9235 14.4184 32.4175 12.6225 31.9425C10.8266 31.4676 4.93398 43.2725 4.83715 45.0874C4.74032 46.9022 10.4511 49.2561 18.2627 40.4561Z",
    fill: "url(#paint12_linear_2_11321)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9358 51.6835C12.0278 50.5261 5.86947 43.8419 3.43703 43.2675C1.0046 42.693 0.427563 53.3511 1.13871 54.2422C1.84986 55.1333 7.24597 55.5938 10.9358 51.6835Z",
    fill: "url(#paint13_linear_2_11321)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6224 31.9423C13.4146 31.8415 15.5664 33.7781 15.7064 36.7385C15.8464 39.6989 6.85727 43.6073 5.25441 43.6373C4.83897 43.6452 8.80558 32.9472 12.6224 31.9423Z",
    fill: "#D96840"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.80597 43.3916C5.1707 44.074 8.73757 47.37 7.67772 50.2388C6.61786 53.1076 2.15862 48.9605 1.87795 46.2788C1.59729 43.5971 2.89921 42.9369 3.80597 43.3916Z",
    fill: "#D96840"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4523 40.1453C18.54 39.5565 18.0297 37.4446 15.0366 38.9023C12.6255 40.1134 10.488 41.8056 8.75593 43.8744C8.05394 44.8558 8.07749 46.7969 8.07749 46.7969C8.07749 46.7969 12.3261 50.8335 18.4523 40.1453Z",
    fill: "#DB83A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33879 46.8C2.36542 48.1873 3.53894 49.4595 4.83893 50.5946C6.51966 52.0941 9.56641 52.889 9.56641 52.889C9.56641 52.889 7.8713 55.2717 3.67113 57.0957C0.434643 58.501 1.1386 54.2393 1.1386 54.2393C1.1386 54.2393 0.409127 51.5629 1.33879 46.8Z",
    fill: "#DB83A9"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94992 50.6564C7.59859 50.8782 4.97381 46.5027 3.3572 46.1422C1.74059 45.7817 2.63231 50.2108 5.94992 50.6564Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.839 53.2321C6.64861 52.6393 3.90214 49.709 2.11085 49.4905C0.319566 49.272 0.549857 53.6998 4.839 53.2321Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7324 37.922C15.7792 36.0136 13.3056 33.3855 11.3416 33.7827C9.37756 34.1798 7.64646 39.7224 7.5529 40.9386C7.45935 42.1549 13.1171 40.8608 14.7324 37.922Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.315 38.6394C17.9034 38.6185 16.451 40.8847 13.6234 41.7889C10.7959 42.693 13.9447 38.6708 16.315 38.6394Z",
    fill: "#9ADD00"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2116 40.6527C11.6459 41.3947 10.9806 42.0551 10.2345 42.6154C9.34806 43.1617 7.4292 43.0217 7.4292 43.0217C8.87085 41.9557 10.49 41.1536 12.2116 40.6527Z",
    fill: "#B2562B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9139 51.3745C5.9139 51.3745 4.43075 50.066 3.84652 49.4825C3.26229 48.8989 2.26851 47.9777 2.26851 47.9777C2.26851 47.9777 2.14683 50.3513 5.9139 51.3745Z",
    fill: "#B2562B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51846 52.5625C7.52762 52.1891 6.56847 51.7364 5.65031 51.2089C4.74473 50.4265 3.88124 49.5966 3.06348 48.7228C3.06348 48.7228 7.37944 50.132 8.51846 52.5625Z",
    fill: "#EA8E40"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2644 38.0401C14.2163 38.9002 13.0829 39.6509 11.882 40.2802C10.3387 40.9999 8.73187 41.1961 7.87417 41.6639C7.24776 42.1032 6.74344 42.6946 6.40869 43.3826C6.75938 43.292 7.10169 43.1716 7.43191 43.0227C7.58565 42.9043 10.1535 41.1085 12.2143 40.6531C12.2117 40.6531 14.5513 39.2027 15.2644 38.0401Z",
    fill: "#EA8E40"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5705 21.5257C56.0043 24.5175 61.371 22.5528 61.371 22.5528C61.371 22.5528 64.5204 31.6957 77.8112 27.6474C90.9828 23.6336 83.3597 15.7246 83.3597 15.7246C83.2812 12.8414 82.6093 11.4721 81.8589 10.8519C81.5428 10.6026 81.164 10.4453 80.7643 10.3974C80.3645 10.3495 79.9593 10.4128 79.5933 10.5804C78.6231 2.69167 72.4896 4.43062 72.4896 4.43062L72.9332 9.05603C64.6899 6.02955 64.3922 15.4296 64.3922 15.4296C63.0445 13.8247 62.6297 14.4175 62.6297 14.4175C62.6297 14.4175 60.9712 10.0184 56.7449 9.92419C52.5185 9.82998 53.1015 16.5699 53.1015 16.5699C52.7399 16.9783 52.4989 17.4791 52.4054 18.0164V18.021C52.2425 18.8793 52.3955 20.0844 53.5705 21.5257Z",
    fill: "url(#paint14_linear_2_11321)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.4101 22.2738C55.8438 25.2656 61.3708 22.5532 61.3708 22.5532C61.3708 22.5532 65.3321 32.2947 78.6229 28.245C91.7945 24.2313 83.3595 15.7237 83.3595 15.7237C83.281 12.8405 82.6091 11.4712 81.8587 10.851C82.6837 15.6007 75.7743 18.1083 75.7743 18.1083C81.5159 19.2781 82.9428 15.9559 82.9428 15.9559C82.9428 15.9559 83.3621 15.7237 84.1125 17.5012C84.8629 19.2788 84.3945 27.4639 73.637 26.669C62.8794 25.8741 62.0499 19.9003 62.0499 19.9003C62.0499 19.9003 58.9246 22.2012 56.1696 21.9199C53.4546 21.6484 52.4372 18.1254 52.4078 18.0194C52.2785 18.7594 52.3007 19.5181 52.473 20.2493C52.6453 20.9806 52.9641 21.6693 53.4101 22.2738Z",
    fill: "url(#paint15_linear_2_11321)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9331 9.05549C75.2229 10.3934 75.5003 8.83827 74.4757 6.55827C73.5088 4.40716 72.4895 4.43006 72.4895 4.43006L72.9331 9.05549Z",
    fill: "url(#paint16_linear_2_11321)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.4073 17.5351C84.1125 17.5024 82.0864 25.6724 74.8839 25.9838C67.6815 26.2952 63.8778 22.0866 63.7836 21.3695C63.6894 20.6525 74.3023 21.4958 81.4073 17.5351Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2574 10.0506C79.1455 12.4058 78.5004 17.0037 70.8302 18.1886C63.16 19.3734 64.999 11.5062 67.1011 9.73392C69.2031 7.9616 73.1795 8.79314 75.2574 10.0506Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3345 13.7841C62.6426 14.1701 58.3633 16.3801 55.8609 16.1465C53.3584 15.9129 53.3512 11.3987 55.5181 10.4167C57.6849 9.43473 59.5704 10.3225 62.3345 13.7841Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1974 19.6541C62.549 18.1107 54.5308 16.729 53.6155 16.9416C52.7002 17.1543 52.7742 21.1372 56.0165 21.7673C59.2589 22.3973 61.1974 19.6541 61.1974 19.6541Z",
    fill: "#9ADD00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6799 10.9662C92.0469 12.1805 88.76 12.5737 87.2553 11.5367C85.7506 10.4997 87.9612 10.085 89.6799 10.9662Z",
    fill: "#EABA13"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.3527 8.69822C89.9088 9.85359 87.6537 10.867 83.3325 9.15619C79.0113 7.44537 84.1221 7.23928 87.3527 8.69822Z",
    fill: "#EABA13"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.0713 5.73907C87.5178 6.24086 84.7628 6.60984 83.3798 6.08188C81.9967 5.55391 83.4308 4.82445 86.0713 5.73907Z",
    fill: "#EABA13"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8443 22.6844C68.0876 23.092 65.4517 23.6743 64.7138 23.4355C63.9758 23.1967 63.5558 22.2697 65.8443 22.6844Z",
    fill: "#EABA13"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5719 24.0734C92.4427 25.1031 88.0286 25.6167 86.9995 25.2425C85.9703 24.8682 85.2671 22.53 89.5719 24.0734Z",
    fill: "#EABA13"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6074 50.7983C48.9738 52.0119 45.6869 52.4058 44.1828 51.3681C42.6788 50.3305 44.8881 49.9164 46.6074 50.7983Z",
    fill: "#EABA13"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2797 48.5292C46.8364 49.6846 44.5806 50.698 40.2601 48.9872C35.9395 47.2764 41.0491 47.0703 44.2797 48.5292Z",
    fill: "#EABA13"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.998 45.571C44.4445 46.0721 41.6896 46.4411 40.3065 45.9131C38.9235 45.3851 40.3575 44.6557 42.998 45.571Z",
    fill: "#EABA13"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7711 62.5162C25.0151 62.9231 22.3786 63.5054 21.6412 63.2666C20.9039 63.0278 20.4826 62.1007 22.7711 62.5162Z",
    fill: "#EABA13"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.4988 63.9045C49.3702 64.9343 44.9555 65.4479 43.9264 65.0743C42.8973 64.7008 42.1959 62.3612 46.4988 63.9045Z",
    fill: "#EABA13"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.4577 87.9863C61.2353 87.1567 43.603 83.2863 38.7388 82.4155C33.8746 81.5447 32.2188 81.9628 32.2188 81.9628C32.2188 81.9628 36.9946 84.1584 41.0457 86.3821C45.0967 88.6059 57.1188 88.4868 59.4577 87.9863Z",
    fill: "#FFDD5E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.7
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8759 94.0139C43.1818 93.6116 34.4923 88.0192 28.8266 85.5292C25.2406 84.0307 21.3253 83.4951 17.4685 83.9754C17.4685 83.9754 28.5512 91.4238 45.8759 94.0139Z",
    fill: "#FFDD5E"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2718 84.7724C75.1462 83.4495 73.4609 81.914 70.6666 80.7816C67.8724 79.6491 60.8577 83.0805 60.1682 83.8244C59.4786 84.5683 67.1403 89.0988 73.2718 84.7724Z",
    fill: "#EDE0A9"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2182 82.2143C60.1178 83.1302 58.2088 84.512 56.8741 83.3716C55.5395 82.2313 58.615 81.6 59.2182 82.2143Z",
    fill: "#EDE0A9"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7346 75.2661C17.174 73.8267 14.6617 68.5347 9.34542 69.1654C4.02913 69.796 10.7873 80.2251 15.7346 75.2661Z",
    fill: "#EDE0A9"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.563 82.5233C73.563 82.5233 73.9738 86.1301 68.2957 86.2348C60.2605 86.3839 60.8493 83.3476 60.8493 83.3476C60.5377 83.5611 60.2472 83.8038 59.9818 84.0725C59.7946 84.3179 62.4135 87.1756 68.1289 86.8576C73.8443 86.5396 74.4377 84.0784 74.3088 83.5923C74.1393 83.1869 73.885 82.8224 73.563 82.5233Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2182 82.214C59.2182 82.214 59.8279 83.2294 58.3716 83.4512C56.9153 83.6729 56.5352 82.8041 56.5352 82.8041C56.5352 82.8041 56.5214 84.2526 58.4691 83.9961C60.4167 83.7397 59.2182 82.214 59.2182 82.214Z",
    fill: "#CC81B3"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1184 71.4998C15.1184 71.4998 16.1998 73.07 15.5109 74.4366C14.822 75.8033 13.0059 76.3339 10.4498 75.0039C9.70687 74.6256 9.0518 74.0953 8.52713 73.4475C8.00246 72.7996 7.61992 72.0487 7.40434 71.2433C7.40075 72.1689 7.64543 73.0785 8.11287 73.8773C8.73685 75.0711 9.76083 76.0074 11.0056 76.5223C12.2503 77.0372 13.6365 77.0979 14.9215 76.6937C18.4301 75.7039 15.6823 71.8786 15.1184 71.4998Z",
    fill: "#CC81B3"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.6627 71.8098C60.0726 73.3989 56.8381 73.5762 55.9032 72.7911C54.9683 72.006 57.4465 70.4398 58.6627 71.8098Z",
    fill: "#B0FF00"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7484 69.2269C57.7782 70.0368 55.9895 70.4045 55.3615 69.7797C54.7334 69.1549 56.0033 68.6414 56.7484 69.2269Z",
    fill: "#B0FF00"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.402 22.8249C110.812 24.4134 107.578 24.5913 106.642 23.8062C105.707 23.0212 108.186 21.4543 109.402 22.8249Z",
    fill: "#B0FF00"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.487 20.2415C108.517 21.0514 106.729 21.4191 106.101 20.7949C105.473 20.1708 106.742 19.6559 107.487 20.2415Z",
    fill: "#B0FF00"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.708 75.73C49.9392 76.4608 47.601 76.6152 46.8055 76.3745C46.0099 76.1337 47.4767 74.9993 48.708 75.73Z",
    fill: "#B0FF00"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.9735 55.5242C98.3274 56.6154 96.0108 56.4362 95.4475 55.4071C94.8842 54.378 97.6928 54.6593 97.9735 55.5242Z",
    fill: "#B0FF00"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3735 53.9252C95.6051 54.2 94.7926 54.1496 94.559 53.9252C94.3255 53.7008 94.9725 53.4483 95.3735 53.9252Z",
    fill: "#B0FF00"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5549 56.0381C92.1273 57.0509 90.4198 58.7499 88.3118 57.5232C86.2039 56.2966 88.128 55.4775 89.5549 56.0381Z",
    fill: "#B0FF00"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7188 36.6645C38.0727 37.7558 35.7561 37.5765 35.1935 36.5481C34.6308 35.5196 37.4381 35.7996 37.7188 36.6645Z",
    fill: "#B0FF00"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1195 35.0658C35.3505 35.3406 34.5386 35.2902 34.3043 35.0658C34.0701 34.8414 34.7178 34.5889 35.1195 35.0658Z",
    fill: "#B0FF00"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3001 37.1795C31.8732 38.1916 30.1657 39.8907 28.0603 38.664C25.955 37.4373 27.8739 36.6182 29.3001 37.1795Z",
    fill: "#B0FF00"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.667 58.3071C65.1096 59.3107 63.7606 59.8504 61.8895 59.1491C60.0184 58.4478 63.0952 57.9093 63.667 58.3071Z",
    fill: "#B0FF00"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2346 20.408C84.088 21.6569 80.2281 22.2444 79.392 21.1545C78.5558 20.0645 80.9876 19.5673 82.2346 20.408Z",
    fill: "#B0FF00"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.2525 24.4605C75.9365 24.7438 74.2525 25.9901 73.0677 25.3673C71.8829 24.7444 72.5692 24.1752 74.2525 24.4605Z",
    fill: "#B0FF00"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.3889 26.456C70.7628 26.825 68.0804 28.0445 67.0814 27.6559C66.0824 27.2673 66.4906 25.6769 69.3889 26.456Z",
    fill: "#B0FF00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4029 67.301C67.7487 66.5022 76.2216 62.3348 82.8261 64.5938C88.0972 66.3969 72.8634 72.7495 68.4029 67.301Z",
    fill: "#DB83A9"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.4309 64.5225C85.0661 62.1601 85.9408 58.7869 85.1852 56.8589C84.4296 54.9308 75.4895 53.8494 71.8592 55.7152C68.2288 57.5811 68.0901 65.2507 69.411 67.0367C70.7319 68.8228 77.5896 68.8614 82.4309 64.5225Z",
    fill: "url(#paint17_linear_2_11321)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8955 57.0078C86.9158 59.5986 75.3529 67.6934 71.5093 64.2083C67.6657 60.7232 70.7988 56.2051 72.4854 55.7151C74.172 55.225 82.4964 53.931 84.8955 57.0078Z",
    fill: "#DB83A9"
  }))), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0152 56.5832C85.2389 57.4854 79.1827 60.1665 75.2318 60.0454C71.2809 59.9244 70.4984 57.5371 70.8589 56.4563C71.2194 55.3755 74.1582 54.7802 78.1405 54.7671C82.1228 54.754 84.8556 55.9388 85.0152 56.5832Z",
    fill: "#FFA7FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.9666 57.1108C85.6863 57.1148 85.331 60.6221 83.2434 63.0788C81.1557 65.5354 76.6795 67.3005 76.2758 67.3005C75.8721 67.3005 76.0841 60.9924 76.1449 60.7471C76.2058 60.5017 80.6454 60.1013 84.9666 57.1108Z",
    fill: "#FFA7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0068 67.5136C75.6368 67.3658 75.9227 61.9304 75.4399 61.1879C74.9571 60.4453 71.1756 59.4214 70.5234 57.5287C70.5234 57.5287 69.2044 58.9726 69.0016 62.6704C68.7988 66.3681 70.2335 68.6337 75.0068 67.5136Z",
    fill: "#DB83A9"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6594 59.634C77.7164 60.2291 76.7278 60.7487 75.7029 61.1878C75.1232 61.3612 73.3967 59.7773 73.3967 59.7773C75.1243 59.3829 76.9129 59.3342 78.6594 59.634Z",
    fill: "#FFFFF0"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0892 59.6804C72.5325 59.5457 72.009 59.2993 71.5504 58.9562C71.3423 58.7712 71.1729 58.5469 71.0517 58.2962C70.9306 58.0455 70.8602 57.7733 70.8445 57.4953C70.8445 57.4953 72.132 59.2395 73.0892 59.6804Z",
    fill: "#FFFFF0"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.7206 67.5057C75.0526 67.9637 75.2312 71.0824 70.7458 71.4501C66.2604 71.8178 68.5436 65.7347 73.7206 67.5057Z",
    fill: "#DB83A9"
  }))), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0587 68.3506C74.4271 67.3993 72.2446 64.2198 70.0378 64.9767C67.8311 65.7336 67.1108 67.8769 68.2662 69.6832C69.4215 71.4896 72.8648 71.4346 74.0587 68.3506Z",
    fill: "url(#paint18_linear_2_11321)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.4765 67.3385C73.6727 68.104 70.9152 70.2387 68.7843 68.9015C66.6535 67.5642 69.6505 65.2273 70.747 65.1822C71.8435 65.137 73.2292 66.3853 73.4765 67.3385Z",
    fill: "#DB83A9"
  }))), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.398 66.4795C73.6675 67.1206 72.185 68.4114 70.3617 68.5671C68.5384 68.7228 67.9652 67.5943 67.9319 67.2587C67.8985 66.9231 69.5871 64.8491 70.6797 64.9793C71.7722 65.1095 73.0467 65.646 73.398 66.4795Z",
    fill: "#FFA7FF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5169 70.6855C71.6955 70.8027 73.1767 69.6806 73.636 68.9302C74.0953 68.1798 73.7518 67.135 73.5856 67.1501C73.4194 67.1651 72.0207 68.3414 70.9098 68.6548C70.9098 68.6548 70.5768 70.0712 71.5169 70.6855Z",
    fill: "#FFA7FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9099 70.7606C71.116 70.7233 70.6397 68.9431 70.4644 68.8175C70.289 68.6919 68.5331 68.6297 67.8187 67.4763C67.8187 67.4763 67.3319 70.4851 70.9099 70.7606Z",
    fill: "#DB83A9"
  }))), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.2469 68.4004C71.2469 68.4004 70.978 69.037 70.7889 69.12C70.5999 69.2031 69.6479 68.5829 69.6479 68.5829C70.1871 68.6022 70.726 68.5407 71.2469 68.4004Z",
    fill: "#FFFFF0"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.402 68.5209C69.0689 68.3455 68.7469 68.1499 68.4376 67.9353C68.2778 67.8099 68.1335 67.6658 68.0078 67.5062C68.0961 67.8052 68.2806 68.0667 68.5327 68.2501C68.7848 68.4336 69.0903 68.5288 69.402 68.5209Z",
    fill: "#FFFFF0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_11321",
    x1: 134.335,
    y1: 100.295,
    x2: 134.335,
    y2: 2.64734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63902F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#84B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#99C407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CC02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_11321",
    x1: 134.333,
    y1: 100.295,
    x2: 134.333,
    y2: 25.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7A70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#E1806E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#F1AD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBC95C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_11321",
    x1: 135.232,
    y1: 80.0316,
    x2: 135.232,
    y2: 6.22137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#63902F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#84B016"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    stopColor: "#99C407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A1CC02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_11321",
    x1: 135.285,
    y1: 81.6561,
    x2: 135.285,
    y2: 28.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2_11321",
    x1: 142.301,
    y1: 90.2385,
    x2: 142.301,
    y2: 74.5904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7A70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.059,
    stopColor: "#E1806E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#F1AD63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#FBC95C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD45A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2_11321",
    x1: 152.958,
    y1: 99.5069,
    x2: 152.958,
    y2: 84.8771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#C46D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#DDAB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#EFD88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FAF492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2_11321",
    x1: 145.371,
    y1: 90.0232,
    x2: 145.371,
    y2: 81.3786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#C46D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#DDAB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#EFD88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FAF492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2_11321",
    x1: 65.1616,
    y1: 62.4798,
    x2: 99.9619,
    y2: 62.4798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA5270"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.124,
    stopColor: "#C46D75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.428,
    stopColor: "#DDAB83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.686,
    stopColor: "#EFD88C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#FAF492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2_11321",
    x1: 97.9518,
    y1: 78.5372,
    x2: 97.9518,
    y2: 54.9227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#AB4449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#B3592D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8661D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2_11321",
    x1: 112.047,
    y1: 65.4852,
    x2: 145.2,
    y2: 65.4852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2_11321",
    x1: 94.7229,
    y1: 49.2958,
    x2: 112.487,
    y2: 49.2958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2_11321",
    x1: 109.012,
    y1: 42.629,
    x2: 119.222,
    y2: 42.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2_11321",
    x1: 191.86,
    y1: 46.8001,
    x2: 191.86,
    y2: 31.9286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#AB4449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#B3592D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8661D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2_11321",
    x1: 197.574,
    y1: 54.8553,
    x2: 197.574,
    y2: 43.2451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A93D54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277,
    stopColor: "#AB4449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "#B3592D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8661D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2_11321",
    x1: 134.561,
    y1: 28.6816,
    x2: 134.561,
    y2: 4.26782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#515E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#457400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2_11321",
    x1: 134.337,
    y1: 29.2304,
    x2: 134.337,
    y2: 10.851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E765E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#938068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#A8AD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816,
    stopColor: "#B5C9AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BAD4B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2_11321",
    x1: 129.734,
    y1: 9.55058,
    x2: 129.734,
    y2: 4.43005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF7A8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.303,
    stopColor: "#EAABB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.616,
    stopColor: "#F5D8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#FCF4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2_11321",
    x1: 344.008,
    y1: 67.1529,
    x2: 342.532,
    y2: 50.8737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#FF9171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#FF5364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#FF265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#FF0A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0054"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2_11321",
    x1: 133.037,
    y1: 71.0087,
    x2: 132.056,
    y2: 63.2736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9572"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#FF9171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#FF5364"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648,
    stopColor: "#FF265B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871,
    stopColor: "#FF0A56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0054"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelevel1);
export default __webpack_public_path__ + "static/media/gamelevel1.595d45882e65c397df6e9fcc1b66407d.svg";
export { ForwardRef as ReactComponent };